import React, { useState } from 'react'
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../../../components/ui/alert-dialog'
import { Button } from '../../../components/ui/button'
import * as Icon from "lucide-react"
import { useMutation } from '@tanstack/react-query'
import useAuth from '../../../hooks/useAuth'
import axios from '../../../lib/axios'
import { useTranslation } from 'react-i18next'
type Props = {
    trigger?: React.ReactNode
}

const DeleteProfile = ({trigger}:Props) => {
    const { t } = useTranslation()
    const {auth, setAuth} = useAuth()
    const [open, setopen] = useState(false);
    
    const { mutate:deleteProfile, isPaused:isDeleting } = useMutation({
        mutationFn: async () => {
            await axios.delete('users', {
                params: {
                    userid: auth.data.m_iUserID
                }
            })
        },
        onSuccess: () => {
            localStorage.removeItem('authToken'); 
            setAuth({data: null,status: null})
        }
    })

  return (
    <AlertDialog open={open} onOpenChange={setopen}>
        {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}
        <AlertDialogContent>
            <AlertDialogHeader>
                <div className='flex items-center justify-center w-10 h-10 mx-auto bg-red-100 rounded-full aspect-square outline outline-8 outline-red-50'>
                    <Icon.AlertTriangle className='w-5 h-5 text-red-600'/>
                </div>
                <AlertDialogTitle className='text-center'>{t('profile.delete_profile.title')}</AlertDialogTitle>
                <AlertDialogDescription className='text-center'>{t('profile.delete_profile.description')}</AlertDialogDescription>
            </AlertDialogHeader>
            
            <AlertDialogFooter>
                <AlertDialogCancel>{t('profile.delete_profile.cancel')}</AlertDialogCancel>
                <Button onClick={()=>{deleteProfile()}} variant='destructive' disabled={isDeleting}>
                    {isDeleting && <Icon.Loader2 className='w-4 h-4 animate-spin'/>}
                    {t('profile.delete_profile.delete')}
                </Button>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteProfile